import { useFetch } from './useFetch'
import type { InventorySystemProfileDTO } from '../types'

export function useInventorySystemProfile(id: string) {
  const { data: profile, isLoading, error } =
    useFetch<InventorySystemProfileDTO | null>(`/v1/inventory-system-profiles/${id}`, null)
  return { profile, isLoading, error }
}
